export var OrganizationSsoProvider;
(function (OrganizationSsoProvider) {
    OrganizationSsoProvider["AZUREAD"] = "azuread";
})(OrganizationSsoProvider || (OrganizationSsoProvider = {}));
export const isOrganizationSsoProvider = (value) => Object.values(OrganizationSsoProvider).includes(value);
//# sourceMappingURL=organizationSso.js.map